export default function BackToTop(){
    this.init = () => {
        const backtotop = document.querySelectorAll('.jsbacktotop');
        backtotop.forEach(function(item){
            item.addEventListener('click', function(e){
                e.preventDefault();
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            })
            let debounceTimeout;
            window.addEventListener('scroll', ()=>{
                clearTimeout(debounceTimeout);
                debounceTimeout = setTimeout(()=> {
                    handle(item);
                }, 300);
            })
            handle();
            function handle(item){
                if (item){
                    if (window.scrollY > 200){
                        item.style.display = "";
                    } else{
                        item.style.display = "none";
                    }
                }
            }
        })

        
    }
}